import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'glass-effect' : 'bg-transparent'
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <h1
              className="text-2xl md:text-3xl font-bold tracking-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              <span className="text-[#FFDA00]">Rovèscio</span>
            </h1>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 items-center">
            <button
              onClick={() => scrollToSection('home')}
              className="text-white hover:text-[#FFDA00] transition-colors duration-300 font-medium"
              data-testid="nav-home"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('prenota')}
              className="text-white hover:text-[#FFDA00] transition-colors duration-300 font-medium"
              data-testid="nav-booking"
            >
              Prenota
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="text-white hover:text-[#FFDA00] transition-colors duration-300 font-medium"
              data-testid="nav-menu"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-white hover:text-[#FFDA00] transition-colors duration-300 font-medium"
              data-testid="nav-gallery"
            >
              Galleria
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-[#FFDA00] transition-colors duration-300 font-medium"
              data-testid="nav-about"
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('recensioni')}
              className="text-white hover:text-[#FFDA00] transition-colors duration-300 font-medium"
              data-testid="nav-reviews"
            >
              Recensioni
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-[#1A1A1A] border-t border-white/10" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left py-2 text-white hover:text-[#FFDA00] transition-colors"
              data-testid="mobile-nav-home"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('prenota')}
              className="block w-full text-left py-2 text-white hover:text-[#FFDA00] transition-colors"
              data-testid="mobile-nav-booking"
            >
              Prenota
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="block w-full text-left py-2 text-white hover:text-[#FFDA00] transition-colors"
              data-testid="mobile-nav-menu"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="block w-full text-left py-2 text-white hover:text-[#FFDA00] transition-colors"
              data-testid="mobile-nav-gallery"
            >
              Galleria
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left py-2 text-white hover:text-[#FFDA00] transition-colors"
              data-testid="mobile-nav-about"
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('recensioni')}
              className="block w-full text-left py-2 text-white hover:text-[#FFDA00] transition-colors"
              data-testid="mobile-nav-reviews"
            >
              Recensioni
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
